import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ e("path", {
  fill: "#0052B4",
  d: "M38.015 28.696A19.92 19.92 0 0 0 40 20a19.92 19.92 0 0 0-1.985-8.696L20 9.565l-18.015 1.74A19.92 19.92 0 0 0 0 20c0 3.116.713 6.066 1.985 8.696L20 30.435l18.015-1.74Z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "M20 40c7.929 0 14.78-4.614 18.015-11.304H1.985C5.22 35.386 12.07 40 20 40Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  fill: "#F0F0F0",
  d: "m34.638 23.926-1.056.825.458 1.26-1.112-.75-1.056.826.37-1.289-1.112-.75 1.34-.046.37-1.29.458 1.26 1.34-.046Zm-2.705-4.686-.71 1.138.861 1.026-1.3-.324-.711 1.137-.094-1.337-1.3-.325 1.243-.502-.094-1.337.862 1.027 1.243-.502Zm-4.145-3.477-.278 1.312 1.16.67-1.332.14-.28 1.311-.544-1.224-1.334.14.997-.897-.546-1.225 1.161.67.996-.897Zm-5.083-1.85.186 1.328 1.32.232-1.204.588.186 1.328-.93-.965-1.206.588.63-1.184-.932-.964 1.32.233.63-1.184Zm-5.41 0 .63 1.184 1.32-.233-.932.964.63 1.184-1.205-.588-.932.965.187-1.328-1.205-.588 1.32-.232.187-1.328Zm-5.084 1.85.997.897 1.16-.67-.545 1.225.996.897-1.333-.14-.545 1.224-.279-1.31-1.333-.14 1.161-.671-.279-1.312ZM8.067 19.24l1.243.503.862-1.027-.094 1.338 1.243.502-1.3.324-.094 1.337-.71-1.136-1.301.324.861-1.027-.71-1.137Zm-2.705 4.686 1.34.047.458-1.26.37 1.289 1.34.047-1.112.75.37 1.288-1.057-.825-1.111.749.458-1.26-1.056-.825Z"
}, null, -1), d = /* @__PURE__ */ e("path", {
  fill: "#FFDA44",
  d: "M38.015 11.304C34.78 4.614 27.93 0 20 0S5.22 4.614 1.985 11.304h36.03Z"
}, null, -1), i = [
  n,
  c,
  s,
  d
];
function _(h, m) {
  return t(), l("svg", o, [...i]);
}
const a = { render: _ };
export {
  a as default,
  _ as render
};
